import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { LOGIN_LINK } from '../../const';
import { ExternalLink } from './ExternalLink';

interface LoginProps {
  variant: 'footer' | 'header';
}

export const Login = ({ variant }: LoginProps) => (
  <ExternalLink variant={variant} href={LOGIN_LINK} category={'Login'}>
    <I18n k="affiliates_signup_perseus.affiliates.login" />
  </ExternalLink>
);
